<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Merchant"
            bc1="App"
            bc2="Merchant"
            bc3="List"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <h5 class="card-header">Search Filter</h5>
          <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
            <div class="col-lg-3 col-sm-12 ">
              <date-picker
                  v-model="startDate"
                  :disabledDate="disableFutureDates"
                  valueType="format"
                  :lang="lang"
                  name="toDate"
                  placeholder="choose starting date"
              ></date-picker>
            </div>
            <div class="col-lg-3 col-sm-12">
              <date-picker
                  v-model="endDate"
                  :disabledDate="disableFutureDates"
                  valueType="format"
                  :lang="lang"
                  name="fromDate"
                  placeholder="choose ending date"
              ></date-picker>
            </div>
            <div class="col-lg-3 col-sm-12">
              <select  class="form-control" v-model="status">
                <option value="">Select Status</option>
                <option value="0">Pending Activation</option>
                <option value="1">Active</option>
                <option value="2">Inactive</option>
                <option value="3">Suspended</option>
                <option value="4">Closed</option>
              </select>
            </div>
          </div>
          <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
            <div class="col-lg-4 mb-1 col-sm-12">
              <input class="form-control" @keyup.enter="onSubmitFilters" type="text" v-model="search" placeholder="Search here..."/>
            </div>
            <div class="col-lg-4 mb-1 col-sm-12">
              <button type="button" class="btn btn-primary"  @click="onSubmitFilters" >Search</button>
              <button type="button" class="ml-1 btn btn-danger " @click="clear" >Clear</button>
            </div>
          </div>

        </div>
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Merchants List</h5>
            <button type="button" class="btn btn-primary" @click="showOnboardModal = true">
              Onboard Merchant
            </button>
          </div>
          <CommonTable
            :url="url"
            :tableHeaderValues="tableHeaderValues"
            :actions="actions"
            :deleteActions="deleteActions"
            :mutedData="mutedData"
            :storageKey="storageKey"
            :externalTotalRecord="externalTotalRecord"
            :filteredData="filteredData"
            @getFullResponse="getFullResponse"
            :show-per-page="true"
            :exportData="exportData"
            :hidePdfExportButton="true"
            :actionDropdown="true"
          />
        </div>
      </div>
    </div>
    <MerchantUpdateStatusModal
        :show="showModal"
        :id="merchantUuid"
        :status="merchantStatus"
        :row="merchantRow"
        :index="merchantIndex"
        vuexKey="merchants"
        @hide="showModal = false"
    ></MerchantUpdateStatusModal>
    <ConfirmationModal :show="showConfirmationModal" @confirm="confirm" bodyClass="font-medium-1" confirmBtnText="Proceed" message="You’ll be redirected to the merchant dashboard. If inactive for 5 minutes, your session will expire automatically."
                       title="Login To Merchant Dashboard"
                       @hide="showConfirmationModal = false"></ConfirmationModal>
    <OnboardMerchantModal
      :show="showOnboardModal"
      @hide="showOnboardModal = false"
      @merchantCreated="onMerchantCreated"
    ></OnboardMerchantModal>
    <TabbyConfigurationModal
      :show="showTabbyConfigModal"
      :row="selectedRowForTabbyConfig"
      type="merchant"
      configurationType="merchantConfigurations"
      modalSize="lg"
      modalTitle="Merchant Service Configuration"
      @hide="showTabbyConfigModal = false"
      @completed="completedTabbyConfig"
    />
    <MerchantReportSettingsModal
      :show="showReportSettingsModal"
      :row="selectedRowForReportSettings"
      @hide="showReportSettingsModal = false"
    />
  </div>
  <!-- END: Content-->
</template>

<script>

import MerchantUpdateStatusModal from "@/pages/dashboard/merchant/MerchantUpdateStatusModal";
import OnboardMerchantModal from "@/pages/dashboard/merchant/OnboardMerchantModal";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import TabbyConfigurationModal from "@/pages/dashboard/merchant/channels/TabbyConfigurationModal.vue";
import MerchantReportSettingsModal from "@/pages/dashboard/merchant/MerchantReportSettingsModal.vue";
export default {
  props: ['propFilters'],
  components: {MerchantUpdateStatusModal, OnboardMerchantModal, DatePicker, TabbyConfigurationModal, MerchantReportSettingsModal},
  mounted() {
    localStorage.setItem("url", "v1/get-merchants");
    this.checkDataInStore('v1/get-merchants')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }

    if(typeof(this.propFilters) != 'undefined' || this.$store.getters.getMerchantPersistFilters != null){

      let propFilters = this.propFilters

      if(this.$store.getters.getMerchantPersistFilters != null){
        propFilters = this.$store.getters.getMerchantPersistFilters
      }

      let filterData = {serviceConfiguration: 1, settlementConfiguration: 1}

      if(propFilters.currentPage){
        filterData.page = propFilters.currentPage
      }

      if(propFilters.search){
        this.search = propFilters.search
        filterData.search = this.search
      }
      if(propFilters.status != ''){
        this.status = propFilters.status
        filterData.status = this.status
      }
      if(propFilters.startDate){
        this.startDate = propFilters.startDate
        filterData.startDate = this.startDate
      }
      if(propFilters.endDate){
        this.endDate = this.propFilters.endDate
        filterData.endDate = this.endDate
      }

      // setTimeout(()=>{
      //   this.filteredData = filterData
      // },1000)

      this.filteredData = filterData
    }

  },
  data() {
    return {
      exportData: {
        cta: (exportType) => {
          let requestData = {
            exportAs: exportType,
            reportType: 'merchants',
          }

          if(this.search != ''){
            requestData.search = this.search
          }
          if(this.status != ''){
            requestData.status = this.status
          }
          if(this.startDate){
            requestData.startDate = this.startDate
          }
          if(this.endDate){
            requestData.endDate = this.endDate
          }


          this.downloadReport(requestData)
        }
      },
      currentPage: 1,
      merchantUuid:'',
      merchantStatus:'',
      merchantIndex:'',
      merchantRow:'',
      showModal: false,
      search: "",
      startDate: null,
      endDate: null,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      url: "v1/get-merchants",
      storageKey: "merchants",
      isDefault: false,
      status: "",
      filteredData: {serviceConfiguration: 1, settlementConfiguration: 1},
      selectedRow: '',
      showConfirmationModal:false,
      showOnboardModal: false,
      showTabbyConfigModal: false,
      showReportSettingsModal: false,
      selectedRowForReportSettings: null,
      selectedRowForTabbyConfig: null,
      force: false,
      tableHeaderValues: [
        {
          title: "UUID",
          valueKey: "uuid",
          html: true,
          alter: (value,row) => {
            var html = "";
            if (value) {
              html = `<span class="text-primary">${value}</span>`;

              if(row.created_by){
                html = `
                <div class="row">
                <div class="col-12">
                ${html}
                </div><p><div class="badge badge-light-dark ml-1" style="margin-top: 0.3rem">${row.created_by.email+'/'+row.created_by.first_name}</div></p></div>`

              }

            } else {
              html = "-";
            }

            return html;
          }
        },
        {
          title: "First Name",
          valueKey: "first_name",
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              return value;
            }
          }
        },
        {
          title: "Last Name",
          valueKey: "last_name",
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              return value;
            }
          }
        },
        {
          title: "Business Name",
          valueKey: "business_name",
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              return value;
            }
          }
        },
        {
          title: "Risk",
          valueKey: "risk",
          html: true,
          alter: (value, row) => {
            var html = "N/A";

            if (value == 1) {
              html = `<span class="badge badge-warning badge-glow badge-sm">Medium</span>`;
            } else if (value == 2) {
              html = `<span class="badge badge-danger badge-glow badge-sm">High</span>`;
            }
            else if (value == 0) {
              html = `<span class="badge badge-success badge-glow badge-sm">Low</span>`;
            }



            return html;
          }
        },
        {
          title: "Email",
          valueKey: "email",
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              return value;
            }
          }
        },
        {
          title: "Partner",
          valueKey: "referral_code",
          html: true,
          alter: function(value) {
            if (!value) {
              return "-";
            }
            let partner = value.user || {}
            let name = ((partner.first_name || '') + ' ' + (partner.last_name || '')).trim()
            let html = name ? `<span class="badge badge-light-dark">${name}</span>` : '-'

            if(value.code){
              html = `
                <div class="row">
                    <div class="col-12 ">
                       ${html}
                        <p class="mb-0"><span class="badge badge-light-primary" style="margin-top: 0.3rem">${value.code}</span></p>
                    </div>
                </div>
                `

            }

            return html;
          }
        },
        {
          title: "Phone",
          valueKey: "phone_number",
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              return value;
            }
          }
        },
        {
          title: "Device",
          valueKey: "device",
          html: true,
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              let html = `<span class="badge badge-info badge-glow badge-sm">${value}</span>`;
              return html;
            }
          }
        },
        {
          title: "Created Date / Time",
          valueKey: "created_at",
        alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: (value, row) => {
            var html = "";

            if (value == 1) {
              html = `<span class="badge badge-success badge-glow badge-sm">Active</span>`;
            } else if (value == 2) {
              html = `<span class="badge badge-danger badge-glow badge-sm">Inactive</span>`;
            } else if (value == 3) {
              html = `<span class="badge badge-info badge-glow badge-sm">Suspended</span>`;
            } else if (value == 4) {
              html = `<span class="badge badge-primary badge-glow badge-sm">Closed</span>`;
            } else if (value == 0) {
              html = `<span class="badge badge-dark badge-glow badge-sm">Pending Activation</span>`;
            }

            if(row.status_reason){
              html = `
                <div class="row">
                    <div class="col-12 ">
                       ${html}
                        <div class="badge badge-light-primary mt-1">${row.status_reason}</div>
                    </div>
                </div>
                `

            }

            // if (row.is_default == 1) {
            //   this.isDefault = true;
            //   html += '<span class="badge badge-secondary ml-1">Default</span>';
            // }

            return html;
          }
        }
      ],
      actions: [
        {
          title: 'Details',
          class: 'btn-primary mt-1 ',
          cta: (row) => {

            let propFilters = {
              search : this.search,
              status : this.status,
              startDate : this.startDate,
              endDate : this.endDate,
            }
            propFilters.currentPage = this.currentPage
            this.$router.push({name: 'merchant-detail',params: {id:row.id,propFilters: propFilters}})
          },

        },
        {
          title: 'Status',
          class: 'btn-primary mt-1 ',
          cta: (row,index) => {
              this.merchantUuid = row.id
            this.merchantStatus = row.status
            this.merchantIndex = index
            this.merchantRow = row
            this.showModal = true
          },

        },
        {
          title: 'Settings',
          class: 'btn-primary mt-1 ',
          cta: (row) => {
            let propFilters = {
              search : this.search,
              status : this.status,
              startDate : this.startDate,
              endDate : this.endDate,
            }
            propFilters.currentPage = this.currentPage
            this.$router.push({name: 'merchant-settings',params: {id:row.id,propFilters: propFilters}})
          },

        },
        {
          title: 'Stores',
          class: 'btn-primary mt-1',
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "merchantStore"
            };

            this.$store.dispatch("set", data);
            let propFilters = {
              search : this.search,
              status : this.status,
              startDate : this.startDate,
              endDate : this.endDate,
            }

            propFilters.currentPage = this.currentPage

            this.$router.push({ name: "store",params: {propFilters: propFilters}});
          },

        },
        {
          title: 'Profile',
          class: 'btn-primary mt-1',
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "merchantProfileData"
            };
            this.$store.dispatch("set", data);

            let propFilters = {
              search : this.search,
              status : this.status,
              startDate : this.startDate,
              endDate : this.endDate,
            }

            propFilters.currentPage = this.currentPage

            this.$router.push({ name: "merchant-profile",params: {propFilters: propFilters}});
          },

        },
        {
          title: 'Onboard As PFAC',
          class: 'badge btn-primary mt-1',
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "merchantPFAC"
            };
            this.$store.dispatch("set", data);

            let propFilters = {
              search : this.search,
              status : this.status,
              startDate : this.startDate,
              endDate : this.endDate,
            }

            propFilters.currentPage = this.currentPage

            this.$router.push({ name: "pfac",params: {propFilters: propFilters}});
          },

        },
        {
          title: 'Login to Dashboard',
          class: 'btn btn-outline-success waves-effect round mt-1 badge',
          cta: async (row) => {
            this.selectedRow = row
            this.showConfirmationModal = true
          },

        },
        {
          title: 'Logs',
          class: 'btn-primary mt-1  ',
          cta: (row) => {

            let propFilters = {
              search : this.search,
              status : this.status,
              startDate : this.startDate,
              endDate : this.endDate,
            }
            propFilters.currentPage = this.currentPage
            this.$router.push({name: 'get-logs',params: {id:row.uuid,propFilters: propFilters}})
          },

        },
        {
          title: "Configuration",
          class: 'badge btn-primary mt-1',
          cta: (row) => {
            this.selectedRowForTabbyConfig = row;
            this.showTabbyConfigModal = true;
          }
        },
        {
          title: "Report Settings",
          class: 'badge btn-primary mt-1',
          cta: (row) => {
            this.selectedRowForReportSettings = row;
            this.showReportSettingsModal = true;
          }
        },
        {
          title: "Settlement Configuration",
          class: 'badge btn-primary mt-1',
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "merchantSettlementConfiguration"
            };
            this.$store.dispatch("set", data);

            let propFilters = {
              search : this.search,
              status : this.status,
              startDate : this.startDate,
              endDate : this.endDate,
            }
            propFilters.currentPage = this.currentPage
            this.$store.dispatch("setMerchantPersistFilters", propFilters);

            this.$router.push({ name: "merchant-settlement-configuration", params: {merchantId : row.id} });
          }
        },
      ],
      deleteActions: [],
      mutedData: [],
      externalTotalRecord: "",

    };
  },
  methods: {
    confirm() {
      let row = this.selectedRow
      this.showConfirmationModal = false
      let payload = {
        merchantId: row.id
      }
      this.$store.dispatch('exportExcelLoader', true)
      this.makeRequest('post', 'v1/access-merchant-dashboard', payload, {}, false,false).then(callResponse => {
        this.$store.dispatch('exportExcelLoader', false)
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let res = callResponse.response.data.data
            this.openNewWindow(res.dashboardUrl)
          }
        }
      });
    },
    getFullResponse(response) {
      if (typeof (response.fullResponse) != 'undefined') {
        let data = response.fullResponse
        this.currentPage = data.paginationData.currentPage

        // for persisting filters
        let propFilters = {
          search : this.search,
          status : this.status,
          startDate : this.startDate,
          endDate : this.endDate,
        }

        propFilters.currentPage = this.currentPage

        this.$store.dispatch("setMerchantPersistFilters", propFilters);


      }
    },
    onSubmitFilters() {

      let filterData = {serviceConfiguration: 1, settlementConfiguration: 1}


      if(this.search != ''){
        filterData.search = this.search
      }
      if(this.status != ''){
        filterData.status = this.status
      }
      if(this.startDate){
        filterData.startDate = this.startDate
      }
      if(this.endDate){
        filterData.endDate = this.endDate
      }

      this.filteredData = filterData






    },
    clear(){
      this.startDate = null
      this.endDate = null
      this.search = ''
      this.status = ''
      this.filteredData = {serviceConfiguration: 1, settlementConfiguration: 1}




    },
    deleteRecord(row) {
      this.makeRequest("post", "v1/delete-role", {
        status: row.status == true ? 1 : 0,
        id: row.id
      });
    },
    onMerchantCreated() {
      this.clear()
    },
    completedTabbyConfig() {
      this.$store.dispatch('renderPagination', !this.force);
      this.force = !this.force;
    }
  },
};
</script>
